'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

type SyncOrderConfirmationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (byPassConfirmationEmail: boolean) => void;
  isPending: boolean;
};

export function SyncOrderConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: SyncOrderConfirmationDialogProps) {
  const { t } = useTranslation('orders');

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('syncDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('syncDialog.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending} onClick={() => onConfirm(true)}>
            {t('syncDialog.doNotSendEmail')}
          </AlertDialogCancel>
          <AlertDialogAction disabled={isPending} onClick={() => onConfirm(false)}>
            {t('syncDialog.sendEmail')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
